
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_8k1rt_1i1h9_5",
  "direction-button": "awsui_direction-button_8k1rt_1i1h9_9",
  "direction-button-visible": "awsui_direction-button-visible_8k1rt_1i1h9_13",
  "direction-button-block-start": "awsui_direction-button-block-start_8k1rt_1i1h9_17",
  "direction-button-block-end": "awsui_direction-button-block-end_8k1rt_1i1h9_21",
  "direction-button-inline-start": "awsui_direction-button-inline-start_8k1rt_1i1h9_25",
  "direction-button-inline-end": "awsui_direction-button-inline-end_8k1rt_1i1h9_29"
};
  